/* eslint-disable prettier/prettier */
import SendIcon from '@material-ui/icons/Send';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Picker from 'emoji-picker-react';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import PollOutlinedIcon from '@material-ui/icons/PollOutlined';
import {
  FaFilePdf,
  FaFileAlt,
  FaFile,
  FaFileVideo,
  FaChevronDown,
  FaArrowCircleUp,
  FaAngleUp,
  FaFileAudio,
  FaImage,
  FaVideo,
} from 'react-icons/fa';
import {
  CreateAttachment,
  ReplyMessage,
  SendMessageUsingContactInformation,
  SendMessageUsingFilter,
  UploadToAws,
} from '../../services/chat';
import Linkify from 'react-linkify';
import {
  getUserGuid,
  getPortalServerIp,
  getIdentificationId,
} from '../../storage';
import {
  autoUrl,
  convertBackendDate,
  getStringDate,
  streamFile,
  getPlainMessageText,
  resolveMessage,
  resolveForward
} from '../../utils';
import loadingIcon from '../../assets/images/loading.gif';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import { TiArrowForward } from 'react-icons/ti';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import './styles.css';
import {
  Content,
  Container,
  SendContent,
  InputContainer,
  MessageContent,
  MessageMarked,
  ButtonClose,
  RepliedMessage,
  ForwardText,
  BottomContent,
  Input,
  AttachmentContainer,
  AttachmentFile,
  Unread,
  ButtonScrollDown,
  DropArea,
  FileDetailsContainer,
  FileName,
  FileTypeSize,
} from './styles';
import { useLoading } from '../../hooks/loading';
import ActionsMessage from '../../components/actionsmessage';
import { useChatMessages } from '../../hooks/chat';
import { GetMessagesForConversations } from '../../services/conversations';
import Forward from '../../components/Forward';
import { IconButton, LinearProgress } from '@material-ui/core';
import DialogImage from './DialogImage';
import CreatePollDialog from './CreatePollDialog';
import { useToast } from '../../hooks/toast';
import { AccessTime, CenterFocusStrong } from '@material-ui/icons';
import { BalloonComponent } from '../../components/balloon';
import { useIntl } from 'react-intl';
import {useDropzone} from 'react-dropzone';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { REACT_APP_ENABLE_SERVERSENTEVENT } from '../../config';
import { useConversation } from '../../hooks/conversation';
import { getE2EEncryptionEnabledFlag } from '../../storage/index';

const Chat = ({ conversationId }) => {
  const intl = useIntl();
  const { startLoading, loading, stopLoading } = useLoading();
  const { addToast } = useToast(false);
  const [openEmoji, setOpenEmoji] = useState(false);
  // prettier-ignore
  const {
    messages,
    hasUpdate,
    unreadMessages,
    addMessageManually,
    setHasUpdate,//added for SSE update purpose
    encryptChatMessage,
    isLoading,
    encryptAttachment,
    decryptAndCreateBlobUrl,
  } = useChatMessages();
  const [files, setFiles] = useState([]);
  const [pastMessages, setPastMessages] = useState([]);
  const [base64File, setBase64File] = useState();
  const [lastUpdate, setLastUpdate] = React.useState(-1);
  const [selectedMessage, setSelectedMessage] = React.useState();
  const [attSelected, setAttSeleted] = React.useState();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedMessageForward, setSelectedMessageForward] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [more, setMore] = React.useState(false);
  // prettier-ignore
  const [moreMessagesAvailable, setMoreMessagesAvailable] = React.useState(
    true
  );
  const userGuid = getUserGuid();
  const messagesEndRef = useRef(null);
  const messagePastRef = useRef(null);
  const scroll = useRef(null);
  const inputSendText = useRef(null);
  const fileRef = useRef(null);
  const formRef = useRef(null);
  const refBottom = useRef(null);
  const [pbottom, setPBottom] = useState(0);
  const [topS, setTopS] = useState(0);
  const urlDownload = `${getPortalServerIp()}/CareServantAttachments/AttachmentManagerService.svc/DownloadAttachment/${getIdentificationId()}`;
  const [loadingMessages, setLoadingMessages] = useState(true);
  const [openPollDialog, setOpenPollDialog] = useState(false);
  const isE2EEnabled = getE2EEncryptionEnabledFlag();

  const {
    conversationDecryptedKey,
    conversationDecryptedIV,
  } = useConversation();

  useEffect(() => {
    setPastMessages([]);
    setMoreMessagesAvailable(true);
    setTopS(0);
    if (!conversationId?.Broadcast && inputSendText.current) {
      inputSendText.current.focus();
    }
  }, [conversationId]);

  const submit = useCallback(
    async (event) => {
      if (event) event.preventDefault();
      try {
        if (!inputSendText.current.value && files.length === 0) {
          addToast({
            title: intl.formatMessage({ id: 'MessageCannotBeEmpty' }),
            type: 'error',
          });
          return;
        }
        startLoading();
        // encrypt message before sending
        const message = isE2EEnabled ? await encryptChatMessage(inputSendText.current.value, conversationId.Guid) : inputSendText.current.value;

        const Attachments = [];
        if (files) {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const result = await CreateAttachment({
              attachmentName: file.name,
              attachmentType: file.type,
            });

            if (result.CreateAttachmentResult) {
              const encryptedAttachment = isE2EEnabled ? await encryptAttachment(file, result.attachment.EncryptionKey, result.attachment.Iv) : "";
              Attachments.push(result.attachment);
              try {
                const response = await UploadToAws({
                  file: isE2EEnabled ? encryptedAttachment : file,
                  attachmentGuid: result.attachment.Guid,
                });
              } catch (error) {
                addToast({
                  title: intl.formatMessage({ id: 'ErrorUploadingFile' }),
                  type: 'error',
                });
              }
            } else {
              addToast({
                title: intl.formatMessage({ id: 'MessageWasNotSent' }),
                type: 'error',
              });
            }
          }
        }

        if (selectedMessage) {
          console.log(selectedMessage)
          if (selectedMessage.action === 'reply') {
            const result = await ReplyMessage({
              messageGuid: selectedMessage.message.Guid,
              reply: message, //inputSendText.current.value
            });
            if (result.repliedMessage) {
              setSelectedMessage();
            }
          }
        } else {
          if (!conversationId.isGroup) {
            await SendMessageUsingContactInformation({
              contactInformation: conversationId.Owner,
              Message: message, //inputSendText.current.value,
              conversationGuid: conversationId.Guid,
              Attachments,
              IsPoll:false,
            });
          } else {
            const response = await SendMessageUsingFilter({
              conversationGuid: conversationId.Owner.StaffGuid,
              Message: message, //inputSendText.current.value
              Attachments,
              IsPoll:false,
            });
          }
        }

        inputSendText.current.value = '';
        setOpenEmoji(false);

        if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
          setHasUpdate(hasUpdate == 0 ? 1 : 0);
        }

        // TODO: not used need to remove
        // setLastUpdate(hasUpdate);
        fileRef.current.value = null;
        setFiles([]); 
        stopLoading();
      } catch (error) {
        stopLoading();
        console.log(error);
        addToast({
          title: intl.formatMessage({ id: 'MessageWasNotSent' }),
          type: 'error',
        });
      }
    },
    [
      conversationId.Guid,
      conversationId.Owner,
      conversationId.isGroup,
      files,
      hasUpdate,
      selectedMessage,
      startLoading,
      stopLoading,
    ]
  );

  const onEmojiClick = (event, emojiObject) => {
    if (inputSendText.current) {  
      inputSendText.current.focus();
    }
    event.preventDefault();
    inputSendText.current.value += '' + emojiObject.emoji;
  };

  const onClinkOpenEmojis = useCallback(() => {
    setOpenEmoji(!openEmoji);
  }, [openEmoji]);

  const scrollToBottom = useCallback(() => {
    setPastMessages([]);
    setLoadingMessages(false);
    setMoreMessagesAvailable(true);
    GetMessagesForConversations({
      Guid: conversationId.Guid,
      maxNumberMessages: 40,
      ...(isE2EEnabled && {
        conversationDecryptedKey: [],
        conversationDecryptedIV: [],
      }),
    }).then((data) => {
      if (data.GetMessagesForConversationResult) {
        messagesEndRef.current.scrollIntoView();
      }
    });
  }, [conversationId.Guid]);

  const scrollSimple = useCallback(() => {
    setPastMessages([]);
    setMoreMessagesAvailable(true);
    setLoadingMessages(false);
    messagesEndRef.current.scrollIntoView();
  }, [messagesEndRef]);

  useEffect(scrollToBottom, [scrollToBottom, hasUpdate, conversationId.Guid]);

  const scrollTo = (event) => {
    setTopS(event.target?.scrollTop);
  };

  const scrollToMessage = (id) => {
    try {
      const div = document.getElementById(id);
      div.scrollIntoView();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (topS < 100) {
      setMore(true);
    }
  }, [topS]);

  useEffect(() => {
    if (messagePastRef && messagePastRef.current) {
      messagePastRef.current.scrollIntoView();
    }
  }, [pastMessages]);

  useEffect(() => {
    const getMoreMessages = async () => {
      const message = pastMessages.length === 0 ? messages[0] : pastMessages[0];
      if (message && moreMessagesAvailable) {
        setLoadingMessages(true);
        const response = await GetMessagesForConversations({
          Guid: message.ConversationGuid,
          indexMessageGuid: message.Guid,
          maxNumberMessages: -20,
          conversationDecryptedKey,
          conversationDecryptedIV
        });
        let list = pastMessages.filter((message) => !!message.Guid);
        if (response.GetMessagesForConversationResult) {
          setMoreMessagesAvailable(response.moreMessagesAvailable);
          let listResponse = response.orderedMessages;
          listResponse.push(
            <div
              key={`oldmessage-anchor-${message.Guid}`}
              ref={messagePastRef}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                alignItems: 'center',
                paddingLeft: 5,
                paddingRight: 5,
                color: '#999',
              }}
            />
          );
          for (let i = 0; i < list.length; i++) {
            const item = list[i];
            listResponse.push(item);
          }
          setPastMessages(listResponse);
          setLoadingMessages(false);
        }
      }
    };
    if (more) {
      getMoreMessages();
    }
    setMore(false);
  }, [more]);

  useEffect(() => {
    console.log('base64File');
    console.log(base64File);
  }, [base64File]);

  const addPollMessage = useCallback(async (message) => {
    // encrypt message before sending
     // encrypt message before sending
     const pollMessage = isE2EEnabled ? await encryptChatMessage(message, conversationId.Guid) : message;

    // const message = await encryptChatMessage(message, conversationId.Guid);

    if (!conversationId.isGroup) {
      await SendMessageUsingContactInformation({
        contactInformation: conversationId.Owner,
        Message: pollMessage,
        conversationGuid: conversationId.Guid,
        IsPoll:true,
      });
    } else {
      const response = await SendMessageUsingFilter({
        conversationGuid: conversationId.Owner.StaffGuid,
        Message: pollMessage,
        IsPoll:true,
      });
    }
    if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
      //TODO: Need to remove
      setHasUpdate(hasUpdate === 0 ? 1 : 0);
    }
    setOpenPollDialog(false);
  }, [conversationId]);

  const getMimeType = (attachmentType) => {
    switch (attachmentType) {
      case 0:
        return 'image/png';
      case 1:
        return 'image/jpeg'; // or detect exact format if needed
      case 10:
        return 'application/pdf';
      case 11:
        return 'text/plain';
      case 100:
        return 'application/octet-stream'; // fallback type for unknowns
      case 20:
        return 'video/mp4'; // or whatever format your videos are in
      default:
        return 'application/octet-stream'; // safe default
    }
  };

  const markedMessage = () => {
    const effectiveMsg =
      resolveForward(selectedMessage.message) || selectedMessage.message;
    const effectiveAttachments = effectiveMsg?.Attachments || [];
    const textToDisplay = effectiveMsg?.IsHtmlMessage
      ? getPlainMessageText(effectiveMsg?.Message)
      : effectiveMsg?.Message;

    return (
      <MessageContent>
        <MessageMarked>
          <AttachmentContainer>
            {effectiveAttachments.map((att, key) => {
              if (isE2EEnabled === 'true') {
                const isEncrypted = att.EncryptionKey && att.Iv;
                const handleAttachmentClick = async () => {
                  const mimeType = getMimeType(att.AttachmentType);
                  const decryptedUrl = await decryptAndCreateBlobUrl(
                    `${urlDownload}/${att.Guid}`,
                    att.EncryptionKey,
                    att.Iv,
                    mimeType,
                    att.Name
                  );  
                };
                return (
                  <AttachmentFile key={key}>
                    {att &&
                      (att.AttachmentType === 0 ||
                        att.AttachmentType === 1) && (
                        <button onClick={handleAttachmentClick}>
                          <FaImage size={30} color="red" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                    )}

                    {att && att.AttachmentType === 20 && (
                      <button onClick={handleAttachmentClick}>
                        <FaVideo size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}

                    {att && att.AttachmentType === 10 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFilePdf size={30} color="red" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}

                    {att && att.AttachmentType === 11 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFileAlt size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}
                    
                    {(att && att.AttachmentType !== 0 &&
                        att.AttachmentType !== 1 &&
                        att.AttachmentType !== 10 &&
                        att.AttachmentType !== 11 &&
                        att.AttachmentType !== 20 &&
                        att.AttachmentType !== 100 && (
                          <button onClick={handleAttachmentClick}>
                            <FaFileAlt size={30} color="#666" />
                            <p title={att.Name}>{att.Name}</p>
                          </button>
                        ))}

                    {att && att.AttachmentType === 100 && (
                      <button onClick={handleAttachmentClick}>
                        <FaFile size={30} color="#333" />
                        <p title={att.Name}>{att.Name}</p>
                      </button>
                    )}
                  </AttachmentFile>
                );
              } else {
                return (
                  <AttachmentFile key={key}>
                    {att &&
                      (att.AttachmentType === 0 || att.AttachmentType === 1) && (
                        <img
                          alt={att.Name}
                          src={`${urlDownload}/${att.Guid}`}
                          onClick={() => setAttSeleted(att)}
                        />
                      )}
                    {att && att.AttachmentType === 20 && (
                      <video controls height="250" width="250">
                        <source src={`${urlDownload}/${att.Guid}`} />
                      </video>
                    )}
  
                    {att && att.AttachmentType === 10 && (
                      <a href={`${urlDownload}/${att.Guid}`} download>
                        <FaFilePdf size={30} color="red" />
                      </a>
                    )}
                    {att && att.AttachmentType === 11 && (
                      <a href={`${urlDownload}/${att.Guid}`} download>
                        <FaFileAlt size={30} color="#333" />
                      </a>
                    )}
                    {att && att.AttachmentType === 100 && (
                      <a href={`${urlDownload}/${att.Guid}`} download>
                        <FaFile size={30} color="#333" />
                      </a>
                    )}
                  </AttachmentFile>
                );
              }
            })}
          </AttachmentContainer>
          {textToDisplay}
          <ButtonClose onClick={() => setSelectedMessage()}>
            <HighlightOffOutlinedIcon />
          </ButtonClose>

        </MessageMarked>
      </MessageContent>
    );
  };

  const handleAttachChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if(selectedFiles.length > 0) {
      const existingFileNames = new Set(files.map(file => file.name + file.size));
  
      const newFiles = selectedFiles.filter(file => !existingFileNames.has(file.name + file.size));
    
      if (newFiles.length === 0) {
        addToast({
          title: intl.formatMessage({ id: 'SelectedFilesAreAlreadyAttached' }),
          type: 'info',
        });
        return;
      }
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const removeFile = (fileToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    fileRef.current.value = null;
  };

  const getImage = () => {
    const imageFiles = files.filter(file => file.type.includes("image"));
    const otherFiles = files.filter(file => !file.type.includes("image"));
  
    const renderFilePreview = (file) => {
      let icon = null;
      let color = "#333";
      let fileType = '';
  
      if (file.type === "application/pdf") {
        icon = <FaFilePdf size={40} color="red" />;
        fileType = "PDF";
      } else if (file.type === "plain/txt") {
        icon = <FaFileAlt size={40} color="#666" />;
        fileType = "Text";
      } else if (file.type.includes("video")) {
        icon = <FaFileVideo size={40} color="#666" />;
        fileType = "Video";
      } else if (file.type.includes("audio")) {
        icon = <FaFileAudio size={40} color="#f777a0" />;
        fileType = "Audio";
      } else {
        icon = <FaFile size={40} color="#333" />;
        fileType = "File";
      }
  
      return (
        <div key={file.name} style={{ width: '150px' }}>
          <MessageContent>
            <MessageMarked style={{ height: 130, width: 130, paddingRight:5 }} >
              {icon}
              <ButtonClose onClick={() => removeFile(file)}>
                <HighlightOffOutlinedIcon />
              </ButtonClose>
              <FileDetailsContainer>
                <FileName title={file.name}>{file.name}</FileName>
                <FileTypeSize>
                  {fileType} <span style={{ padding: '0px 2px' }}>|</span>{' '}
                  {(file.size / (1024 * 1024)).toFixed(2)} MB
                </FileTypeSize>
              </FileDetailsContainer>
            </MessageMarked>
          </MessageContent>
        </div>
      );
    };
  
    const renderImagePreview = (file) => {
      return (
        <div key={file.name} style={{ marginRight: '10px'}}>
          <MessageContent>
            <MessageMarked style={{ height: 130, width: 130 }} >
              <img src={URL.createObjectURL(file)} alt="" style={{ height: 100, width: 100 }} />
              <ButtonClose onClick={() => removeFile(file)}>
                <HighlightOffOutlinedIcon />
              </ButtonClose>
            </MessageMarked>
          </MessageContent>
        </div>
      );
    };
  
    return (
      <div style={{ marginLeft: '90px', maxHeight: '300px', overflowY: 'auto', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {otherFiles.map((file, index) => renderFilePreview(file, index))}
        {imageFiles.map((file, index) => renderImagePreview(file, index))}
      </div>
    );
  }; 

  useEffect(() => {
    if (selectedMessageForward) {
      setOpen(true);
    }
  }, [selectedMessageForward]);

  useEffect(() => {
    if (inputSendText.current) {
      inputSendText.current.focus();
    }
  }, [selectedMessage]);

  useEffect(() => {
    if (openEmoji) {
      scrollSimple();
    }
  }, [openEmoji, scrollSimple]);

  useEffect(() => {
    if (!refBottom.current) return;

    setPBottom((state) => refBottom.current?.clientHeight);
  }, [conversationId]);

  useEffect(() => {
    scrollToBottom();
  }, [pbottom]);

  const handleKeyDown = (event) => {
    if (event.which === 13 && !event.shiftKey) {
      // console.log(refBottom.current.clientHeight);
      submit();
      event.preventDefault();
    }
    if (event.which === 13 && event.shiftKey) {
      // event.preventDefault();
    }
  };

  useEffect(() => {
    if (attSelected) {
      setOpenDialog(true);
    }
  }, [attSelected]);

  const dispatchChangeEvent = () => {
    if (fileRef.current) {
      const event = new Event('change', { bubbles: true });
      fileRef.current.dispatchEvent(event);
    }
  };
  
  const onDrop = useCallback(async (acceptedFiles) => {
    if (fileRef.current) {
      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach(file => dataTransfer.items.add(file));
      fileRef.current.files = dataTransfer.files;
  
      dispatchChangeEvent();
    }
  }, []);

  const {
    getRootProps,
    isDragAccept,
    isDragReject,
    isDragActive
  } = useDropzone({
    onDrop,
    noClick: true,
  });

  return (
    <>
      { isDragActive && 
        <DropArea {...getRootProps({ isDragAccept, isDragReject, isDragActive })}>
          <CloudUploadOutlinedIcon style={{ marginRight: '10px' }} />
          {isDragActive && !isDragReject && <p>Drop files here</p>}
          {isDragReject && <p>Some files will be rejected</p>}
        </DropArea>
      }
      
      <Container
        {...getRootProps({ isDragAccept, isDragReject, isDragActive })}
        onScroll={scrollTo}
      >
        <Content
          isMessageSelected={!!selectedMessage}
          isEmojisOpened={!!openEmoji}
          height={pbottom - 20}
        >
          {(loadingMessages || isLoading) && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 5,
                right: 0,
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <LinearProgress
                color="secondary"
                variant="indeterminate"
                style={{ width: '100%' }}
              />
            </div>
          )}

          {pastMessages.map((message) => {
            if (message && message.Guid) {
              let formatedDate = new Date(
                convertBackendDate(message.MessageDateTime)
              );
              const isDeleted =
                message.Message ===
                intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' });
              const resolvedMsg = resolveMessage(message);
              let text = isDeleted
                ? intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' })
                : (resolvedMsg?.Message || message.Message || '');

              return (
                <React.Fragment key={message.Guid}>
                  {unreadMessages.length > 0 &&
                    unreadMessages[0].Guid === message.Guid && (
                      <Unread key={unreadMessages[0].Guid}>
                        {intl.formatMessage({ id: 'UnreadMessages' })};
                      </Unread>
                    )}
                  <BalloonComponent
                    scrollTo={scrollToMessage}
                    message={message}
                    text={text}
                    conversationId={conversationId}
                    isDeleted={isDeleted}
                    userGuid={userGuid}
                    formatedDate={formatedDate}
                    urlDowload={urlDownload}
                    setAttSeleted={setAttSeleted}
                    setSelectedMessage={setSelectedMessage}
                    setSelectedMessageForward={setSelectedMessageForward}
                    setOpen={setOpen}
                    decryptAndCreateBlobUrl={decryptAndCreateBlobUrl}
                  />
                </React.Fragment>
              );
            } else {
              return message;
            }
          })}

          {messages.map((message) => {
            let formatedDate = '';
            const isDeleted =
              message.Message ===
              intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' });
            formatedDate = new Date(
              convertBackendDate(message.MessageDateTime)
            );

            const effectiveMsg = resolveForward(message) || message;
              let text = isDeleted
                ? intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' })
                : (effectiveMsg.Message || '');


            return (
              <React.Fragment key={message.Guid}>
                {unreadMessages.length > 0 &&
                  unreadMessages[0].Guid === message.Guid && (
                    <Unread key={unreadMessages[0].Guid}>
                      {intl.formatMessage({ id: 'UnreadMessages' })};
                    </Unread>
                  )}
                <BalloonComponent
                  scrollTo={scrollToMessage}
                  message={message}
                  text={text}
                  conversationId={conversationId}
                  isDeleted={isDeleted}
                  userGuid={userGuid}
                  formatedDate={formatedDate}
                  urlDowload={urlDownload}
                  setAttSeleted={setAttSeleted}
                  setSelectedMessage={setSelectedMessage}
                  setSelectedMessageForward={setSelectedMessageForward}
                  setOpen={setOpen}
                  decryptAndCreateBlobUrl={decryptAndCreateBlobUrl}
                />
              </React.Fragment>
            );
          })}
          
          <div ref={messagesEndRef} />
        </Content>
      </Container>

      {scroll !== null &&
        scroll.current?.scrollHeight - scroll?.current?.scrollTop !==
          scroll.current?.clientHeight && (
          <ButtonScrollDown {...getRootProps({ isDragActive })}>
            <IconButton size="small" color="inherit" onClick={scrollSimple}>
              <FaChevronDown size={16} />
            </IconButton>
          </ButtonScrollDown>
        )}

    {!conversationId?.Broadcast && (
  
      <BottomContent ref={refBottom}>
        {selectedMessage && markedMessage()}

        {files.length > 0 && getImage()}

        {openEmoji && <Picker onEmojiClick={onEmojiClick} />}

        <SendContent ref={formRef} onSubmit={submit}>
          <IconButton
                title={intl.formatMessage({
                  id: 'CreatePoll',
                })}
                onClick={() => setOpenPollDialog(true)}
              >
                <PollOutlinedIcon />
          </IconButton>
          <label htmlFor="attach">
            <AttachFileIcon />
            <input
              ref={fileRef}
              multiple
              type="file"
              id="attach"
              onChange={handleAttachChange}
            />
          </label>
          <IconButton onClick={onClinkOpenEmojis}>
            <InsertEmoticonIcon />
          </IconButton>
          <InputContainer>
            <Input
              autoFocus={true}
              spellCheck={false}
              multiline
              inputRef={inputSendText}
              placeholder={intl.formatMessage({ id: 'TypeMessage' })}
              onKeyDown={handleKeyDown}
            />
            {loading && <img src={loadingIcon} alt="loading" />}
          </InputContainer>
          <button type="submit">
            <SendIcon />
          </button>
        </SendContent>
      </BottomContent>
    )}

      <Forward
        open={open}
        message={selectedMessageForward}
        conversation={conversationId}
        handleClose={() => {
          setOpen(false);
          setSelectedMessageForward();
        }}
      />

      <DialogImage
        att={attSelected}
        open={openDialog}
        close={() => setOpenDialog(false)}
      />
      
      <CreatePollDialog
        handleCancel={() => setOpenPollDialog(false)}
        handleOk={addPollMessage}
        open={openPollDialog}
      />
    </>
  );
};
export default Chat;
